import { render, staticRenderFns } from "./CTextColumn.vue?vue&type=template&id=166ab2b4"
import script from "./CTextColumn.vue?vue&type=script&lang=js"
export * from "./CTextColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166ab2b4')) {
      api.createRecord('166ab2b4', component.options)
    } else {
      api.reload('166ab2b4', component.options)
    }
    module.hot.accept("./CTextColumn.vue?vue&type=template&id=166ab2b4", function () {
      api.rerender('166ab2b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CTextColumn.vue"
export default component.exports